module.exports = __webpack_public_path__ + "img/1.1e8ccea3.png";